<div
    id="formContainer"
    [@submitAnimation]="isSubmitted ? 'submitted' : 'notSubmitted'"
>
    <div class="flex justify-between items-center">
        <h3 class="text-3xl text-[#595959] font-bold mb-2 mt-2">
            {{ formTitle }}
        </h3>
        <ng-container *ngIf="isDialog">
            <button
                mat-icon-button
                mat-dialog-close
                class="cursor-pointer bg-transparent border-none"
            >
                <mat-icon aria-label="Close dialog">close</mat-icon>
            </button>
        </ng-container>
    </div>
    <div class="form-fields">
        <shared-app-form
            [formOptions]="options"
            (formSubmit)="submittedForm($event)"
            [customButtonName]="'Update'"
        >
        </shared-app-form>
    </div>
</div>
